import UserReducer from './userReducer';
import ApiReducer from './apiReducer';

export default {
    UserReducer, ApiReducer
};